import { render, staticRenderFns } from "./SelectCardsModal.vue?vue&type=template&id=27156a3c"
import script from "./SelectCardsModal.vue?vue&type=script&lang=js"
export * from "./SelectCardsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports